export default {
      id: "ic-misc-mail-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-mail-usage",
      toString: function () {
        return this.url;
      }
    }